/**
 * Created by Administrator on 2017/6/7.
 */
import config from 'src/core/config'

var storage = window.localStorage

var pre = ''
// var pre = ''

function isJSON(obj) {
  var checkjson = typeof (obj) === 'object' && Object.prototype.toString.call(obj).toLowerCase() == '[object object]' && !obj.length
  return checkjson
}

export default {
  set(name, value) {
    if (isJSON(value))value = JSON.stringify(value)
    return storage.setItem(pre + name, value)
  },
  get(name) {
    let data = storage.getItem(pre + name) || `{}`
    return data
  },
  remove(name) {
    return storage.removeItem(pre + name)
  },
  getKey(name) {
    if (name =="carromclash") {
      return 'gamedata_carromclash_1_0_0'
    }

    if (name =="knifesmash") {
      return 'inl_knsm-data'
    }
    if (name =="tilesofegypt") {
      return 'TilesOfEgypt7Save'
    }
    return ''
  }

}



// WEBPACK FOOTER //
// src/helper/localstorageGame.js